module.exports = __webpack_public_path__ + "img/icon_pedometer_download_code.cafec49c.png";